// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-landing-page -> ctl-management-landing-page -> sunset-summit
// Generated: 2026-09-23T19:54:41.173Z
// Counts: 1 design, 11 content, 2 slot group, 2 collection binding, 3 section, 0 style

export const designOverrides = {
  "design.SpecialOffers.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_color_4"
  }
};

export const contentOverrides = {
  "header.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_ppc_tracking_phone_number"
  },
  "hero.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "multihub-lead-capture.lead_source": {
    "overrideType": "VALUE",
    "customValue": "LANDING_PAGE",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/company/5767906449162446/019de45f-df6f-7750-bec5-e26263c2e1b3.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_ppc_tracking_phone_number"
  },
  "fees.pet_policy": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pet_policy_description"
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_ppc_tracking_phone_number"
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "privacy-consent.opt_out_scope": {
    "overrideType": "VALUE",
    "customValue": "all",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_ppc_tracking_phone_number"
  },
  "neighborhoodmap.description": {
    "overrideType": "VALUE",
    "customValue": "Rocklin, California sits just 21 miles northeast of Sacramento along I-80. This busy city is more than a suburb -- it is home to Sierra College and William Jessup University. It is filled with shopping plazas, such as the large Blue Oaks Town Center, and a section of Granite Drive is known as \"Toy Row\". Rocklin is directly north of Roseville and residents enjoy easy access to Westfield Galleria at Roseville, providing even more shopping.\t\t\t\t\tYou'll enjoy fantastic mountain views when you move to a Rocklin apartment -- the city is surrounded by the Sierra Nevada Mountains and the Sutter-Butte mountain range. Quarry Park features hiking trails and an amphitheater where concerts are often held.\t\t\t\t\tRocklin has a secret -- the Secret Ravine, that is, which played a large role during the California Gold Rush. Later, Rocklin became a major granite-mining town -- be sure to take some of the Quarry History Tours after moving to Rocklin.\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tLearn more about living in Rocklin",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "header.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "query_params": {
        "type": "VALUE",
        "customValue": "?utm_medium=ppc&utm_source=google&utm_campaign=landing-page"
      }
    }
  },
  "hero.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "neighborhoodmap.pois": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "privacy-consent",
      "blockId": "privacy-consent",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
